module.exports = __webpack_public_path__ + "static/media/carta_74.e3ed7e66.jpg";